import { AvailableBrokerageOfferingSearchRequestQuery } from '@lio/api-types';

export const searchProductOfferingsQueryParams = (params: AvailableBrokerageOfferingSearchRequestQuery) => {
  const { offeringId, jurisdictionId, effectiveDate, insuranceProductId, includeInherited } = params;
  const queryParams = new URLSearchParams();
  if (insuranceProductId) {
    queryParams.append('insuranceProductId', insuranceProductId);
  }
  if (offeringId) {
    queryParams.append('offeringId', offeringId);
  }
  if (effectiveDate) {
    queryParams.append('effectiveDate', effectiveDate.toISOString());
  }
  if (jurisdictionId) {
    queryParams.append('jurisdictionId', jurisdictionId);
  }
  if (includeInherited) {
    queryParams.append('includeInherited', 'true');
  }
  return queryParams.toString();
};
